export enum FieldGroupTypes {
  /** Group with a dropdown for type of event and the number of attendees */
  EVENT_TYPE = 3,

  /** Group to choose the star date and number of days */
  START_DATE = 4,

  /** Group to enter budget + dropdown currency */
  BUDGET = 5,

  /**
   * Group to choose (radio icon) the Meeting Room Setup
   * (U-Shape, Theater, Classroom, etc...)
   * */
  ROOM_SETUP = 6,

  /** Group to check events to add (Breakfast, Welcome Reception, etc..) */
  ADD_EVENTS = 7,

  /** Group to request guest rooms (date, nb, comment request) */
  GUEST_ROOMS = 8,

  /** Group to enter other request */
  OTHER_REQUEST = 10,

  /** Group to enter compny name */
  COMPANY_NAME = 11,

  /** Group to enter contact information (first name, lastname, etc) */
  CONTACT_INFORMATION = 12,

  /** Group to enter postal information (address, city, etc...) */
  POSTAL_INFORMATION = 15,

  /** Date field to specify before when the reply should be */
  NEED_REQUEST_BY = 16,

  /** AdditionalInformation - TEXTAREA - Can be added several time */
  ADDITIONAL_INFORMATION = 17,

  /** AdditionalInformation - PREFERED TIME */
  ADDITIONAL_INFORMATION_PREFERRED_TIME = 18,

  /** AdditionalInformation - Dropdown - Can be added several time */
  ADDITIONAL_INFORMATION_DROPDOWN = 19,

  /** Attachments */
  ATTACHMENTS = 20,

  /** Title or divider bar */
  TITLE_SECTION = 21,

  /**
   * Field to choose event name
   * does not have a speific type ID
   * because it's not sent by Galaxy "steps"
   */
  EVENT_NAME = 'EVENT_NAME',

  /**
   * accept copy does not have a specific type ID
   * because it's not sent by Galaxy "steps"
   */
  LOCATIONS = 'LOCATIONS',

  /**
   * accept terms does not have a type ID
   * because it's not sent by Galaxy "steps"
   */
  ACCEPT_TERMS = 'ACCEPT_TERMS',
}
